export function formatNumber(number: number): string {
  return Math.ceil(number).toLocaleString(); // Rounds up to the nearest integer and adds commas
}

export function isDarkMode(): boolean {
  // Simulate dark mode toggle (you can extend this with localStorage or state)
  return false; // Default to light mode; update dynamically in UI
}
